import { PowerTransformerConnectionState } from './types';

const state = (): PowerTransformerConnectionState => {
  return {
    powerTransformerConnections: [],
  };
};

export default state;
